/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Approvers_Admin_OnlyInputs */



/**
* | output |
* | --- |
* | "Only an administrator can designate approvers on a shared agent. Without approvers, the person who started a run approves it." |
*
* @param {Agent_Builder_Approvers_Admin_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_approvers_admin_only = /** @type {((inputs?: Agent_Builder_Approvers_Admin_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Approvers_Admin_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Freigebende Personen für einen geteilten Agenten kann nur eine Administratorin oder ein Administrator festlegen. Ohne freigebende Personen gibt die Person frei, die einen Lauf gestartet hat.")
	return /** @type {LocalizedString} */ ("Only an administrator can designate approvers on a shared agent. Without approvers, the person who started a run approves it.")
});